import { useEffect } from 'react';
import { TopBar } from './components/layout/TopBar';
import { NavRail } from './components/layout/NavRail';
import { HomeView } from './components/views/HomeView';
import { ListView } from './components/views/ListView';
import { DashboardView } from './components/views/DashboardView';
import { FeedView } from './components/views/FeedView';
import { SearchView } from './components/views/SearchView';
import { FoldersView } from './components/views/FoldersView';
import { TagKpiView } from './components/views/TagKpiView';
import { ContactsView } from './components/views/ContactsView';
import { SavedItemsView } from './components/views/SavedItemsView';
import { ChangelogView } from './components/views/ChangelogView';
import { ManualiView } from './components/views/ManualiView';
import { LinkedInView } from './components/views/LinkedInView';
import { DeletionParkingView } from './components/views/DeletionParkingView';
import { SentView } from './components/views/SentView';
import { DeletionAlert } from './components/layout/DeletionAlert';
import { Breadcrumbs } from './components/layout/Breadcrumbs';
import { AddAccountDialog } from './components/account/AddAccountDialog';
import { SettingsDialog } from './components/settings/SettingsDialog';
import { LoginScreen } from './components/auth/LoginScreen';
import { useAuth } from './store/auth';
import { usePortal } from './store/portal';
import { useUiStore } from './store/ui';

export default function App() {
  const { user, loading, init } = useAuth();
  const initPortal = usePortal((s) => s.init);
  const currentView = useUiStore((s) => s.currentView);

  useEffect(() => {
    init();
    initPortal();
  }, [init, initPortal]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-zinc-950 text-zinc-500">
        <div className="animate-pulse text-sm">Caricamento…</div>
      </div>
    );
  }

  if (!user) return <LoginScreen />;

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-zinc-950 text-zinc-100">
      {/* Rail di primo livello: sezioni della piattaforma (Home, Mail, LinkedIn, social, Novità, Config) */}
      <NavRail />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
      <TopBar />
      {/* Banner ben visibile: posta nel parcheggio cancellazione 48h */}
      <DeletionAlert />
      {/* Breadcrumb di navigazione: presente in tutte le sezioni */}
      <Breadcrumbs />
      <div className="flex flex-1 overflow-hidden">
        {/* Navigazione a viste (Zustand, niente react-router). 'settings' usa il dialog, quindi
            resta visibile la vista sottostante: fallback al Feed. */}
        {currentView === 'home' ? (
          <HomeView />
        ) : currentView === 'list' ? (
          <ListView />
        ) : currentView === 'dashboard' ? (
          <DashboardView />
        ) : currentView === 'search' ? (
          <SearchView />
        ) : currentView === 'folders' ? (
          <FoldersView />
        ) : currentView === 'kpi' ? (
          <TagKpiView />
        ) : currentView === 'contacts' ? (
          <ContactsView />
        ) : currentView === 'saved' ? (
          <SavedItemsView />
        ) : currentView === 'changelog' ? (
          <ChangelogView />
        ) : currentView === 'manuali' ? (
          <ManualiView />
        ) : currentView === 'linkedin' ? (
          <LinkedInView />
        ) : currentView === 'deletion' ? (
          <DeletionParkingView />
        ) : currentView === 'sent' ? (
          <SentView />
        ) : (
          <FeedView />
        )}
      </div>
      </div>
      <AddAccountDialog />
      <SettingsDialog />
    </div>
  );
}
